import React, { useState, useEffect } from "react";
import {
  Avatar,
  Grid,
  Typography,
  Box,
  Link,
  Stack,
  Divider,
} from "@mui/material";
import { StaffGetGrouped } from "../../api/orgService";
import useApi from "../../api/useApi";
import SkeletonList from "./SkeletonList";

// Example data
const leadershipTeams = {
  executive: {members:[
    {
      name: "Courtney Cox",
      role: "Executive Director and Co-founder of Fountain Africa Trust",
      location: "Kenya",
      image: "https://randomuser.me/api/portraits/women/12.jpg",
      email: "courtney@example.com",
    },
    // {
    //   name: "Ebrima Saidy",
    //   role: "Chief Executive Officer",
    //   location: "Bristol, UK",
    //   image: "https://randomuser.me/api/portraits/men/15.jpg",
    //   email: "ebrima@example.com",
    // },
    // {
    //   name: "Gildas Andriamalala",
    //   role: "Madagascar Country Director",
    //   location: "Antananarivo, Madagascar",
    //   image: "https://randomuser.me/api/portraits/men/21.jpg",
    //   email: "gildas@example.com",
    // },
    // {
    //   name: "Kevin Moyes",
    //   role: "Chief People Officer",
    //   location: "Bristol/London, UK",
    //   image: "",
    //   email: "kevin@example.com",
    // },
    // {
    //   name: "Sharon Young",
    //   role: "Chief Partnership Officer",
    //   location: "Belize",
    //   image: "https://randomuser.me/api/portraits/women/44.jpg",
    //   email: "sharon@example.com",
    // },
  ],outro:""},
  senior: {members: [
    {
      name: "Annie Towette",
      role: "Director of Health Services",
      location: "Nairobi, Kenya",
      image: "",
      email: "annie@example.com",
    },
    {
        name: "Barry Grimshaw",
        role: "Director of Finance and Logistics ",
        location: "Cape Town, South Africa",
        image: "",
        email: "barry@example.com",
      },
    {
      name: "Barry Grimshaw",
      role: "Director of Disability and Inclusion Programs ",
      location: "Cape Town, South Africa",
      image: "https://randomuser.me/api/portraits/men/31.jpg",
      email: "barry@example.com",
    },
    {
      name: "Davide Grazi",
      role: "Communication and Advocacy",
      location: "Rome, Italy",
      image: "",
      email: "davide@example.com",
    },
  ],outro:""},
  board:{members:[
    {
        name: "Barry Grimshaw",
        role: "Director of Disability and Inclusion Programs ",
        location: "Cape Town, South Africa",
        image: "https://randomuser.me/api/portraits/men/31.jpg",
        email: "barry@example.com",
        description:"lorem ipsum "
      },
      {
        name: "Davide Grazi",
        role: "Communication and Advocacy",
        location: "Rome, Italy",
        image: "",
        email: "davide@example.com",
        description:"lorem ipsum "
      },
  ],outro:""} ,
  committee:{members:[
    {
        name: "Barry Grimshaw",
        role: "Director of Disability and Inclusion Programs ",
        location: "Cape Town, South Africa",
        image: "https://randomuser.me/api/portraits/men/31.jpg",
        email: "barry@example.com",
      },
      {
        name: "Davide Grazi",
        role: "Communication and Advocacy",
        location: "Rome, Italy",
        image: "",
        email: "davide@example.com",
      },
  ],outro:"guided by distinguished experts from Kenya Medical Research, University of Geneva, and University of Nairobi"},
};

const LeadershipTeam = () => {
  const [AllStaff,setAllStaff] = useState({})
  const { request: getAllStaff, data:staffData, error:staffError, isLoading:getStaffIsLoading} = useApi(StaffGetGrouped);
  
  useEffect(() => {
    getAllStaff();
          // eslint-disable-next-line
    }, []);
              
  useEffect(()=>{
    if (staffData?.status===200) {
      setAllStaff(staffData?.data);
    }
  // eslint-disable-next-line
  },[staffData])

  let staffEntries = Object.entries(AllStaff?.results || {});

  staffEntries = staffEntries.reverse()

  console.log(staffEntries)

  const renderTeam = (title, members,outro,board) => (
    <Box sx={{ mt: 6 }}>
      <Typography variant="h5" fontWeight="600" color="#1D3A89"sx={{ mb: 4 }}>
        {title}
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {members?.map((member, index) => (
          <Grid item xs={6} sm={4} md={2.4} key={index}>
            <Stack alignItems="center" spacing={1.5}>
              <Avatar
                src={member.image || ""}
                alt={member?.staff_user?.username}
                sx={{
                  width: 120,
                  height: 120,
                //   bgcolor: "#1976d2",
                  bgcolor: "#1D3A89",
                  fontSize: 28,
                }}
              >
                {!member.image &&
                  member?.staff_user?.username
                    .split(" ")
                    .map((n) => n[0])
                    .join("")
                    .toUpperCase()}
              </Avatar>

              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "600",
                  color: "#1976d2",
                  textAlign: "center",
                }}
              >
                {member?.staff_user?.username}
              </Typography>

              <Typography
                variant="body2"
                color="text.secondary"
                textAlign="center"
                sx={{ fontStyle: "italic" }}
              >
                {member?.title}
              </Typography>

              <Typography
                variant="body2"
                color="text.secondary"
                textAlign="center"
              >
                {member?.base}
              </Typography>

              {board==="ceo"?(<Link
                href={`mailto:${member?.email}`}
                underline="hover"
                color="#1976d2"
                sx={{ fontSize: "0.9rem" }}
              >
                Read more
              </Link>):""}
              {
              board==="board"?( <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "600",
                  color: "#1976d2",
                  textAlign: "center",
                }}
              >
                {member.description ||""}
              </Typography>):""
              }
            </Stack>
          </Grid>
        ))}
      </Grid>
      {outro && <Typography variant="h5" fontWeight="600" sx={{ mb: 4 }}>
        {outro}
      </Typography>}
    </Box>
  );

  if(getStaffIsLoading){
    return SkeletonList
  }

  return (
    <Box sx={{ py: 8, px: { xs: 3, md: 10 }, bgcolor: "#fff" }}>
      <Typography
        variant="body1"
        color="text.secondary"
        textAlign="center"
        sx={{ maxWidth: "800px", mx: "auto", mt: 2 }}
      >
        To guide our work, we use a distributed leadership model that keeps our
        decision-making as close to the communities we serve as possible.
      </Typography>

{/* {console.log(staffEntries)} */}

      {staffEntries?.length > 0 &&
      Object.entries(staffEntries)?.map(([teamName, members]) => (
        <React.Fragment key={teamName}>
          {/* {console.log(teamName)} */}
          {renderTeam(staffEntries[teamName][0], members[1], null, "board")}
          <Divider sx={{ my: 8 }} />
        </React.Fragment>
      ))}
      
        {/* {
        AllStaff?.results?.legnth>0 && Object?.entries(AllStaff?.results)?.map(([teamName, members]) => (
          <>
          {renderTeam(`${teamName}`, members,null,"board")}
          <Divider sx={{ my: 8 }} />
          </>
        ))} */}


      {/* {renderTeam("Our Executive Leadership Team", leadershipTeams?.executive?.members,null,"ceo")}

      <Divider sx={{ my: 8 }} />

      {renderTeam("Our Senior Leadership Team", leadershipTeams?.senior?.members)}
      <Divider sx={{ my: 8 }} />

      {renderTeam("Board of Management", leadershipTeams.board?.members,null,"board")}

      <Divider sx={{ my: 8 }} />

      {renderTeam("Advisory Committee", leadershipTeams?.committee?.members,leadershipTeams.committee?.outro)} */}
    </Box>
  );
};

export default LeadershipTeam;
